'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeHeatmapIcon = function TraceTypeHeatmapIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h46v46H0z' }),
        _react2.default.createElement('path', { fill: '#1d9bfb', d: 'M32 20h6v6h-6zm-12-6h6v6h-6zm-6 6h6v6h-6zm0 12h6v6h-6zm6 0h6v6h-6zm12 0h6v6h-6zm-6-12h6v6h-6z' }),
        _react2.default.createElement('path', { fill: '#25fdfc', d: 'M26 14h6v6h-6zm6 0h6v6h-6zm-12 6h6v6h-6zM8 20h6v6H8z' }),
        _react2.default.createElement('path', { fill: '#1d9bfb', d: 'M14 14h6v6h-6z' }),
        _react2.default.createElement('path', { fill: '#25fdfc', d: 'M8 14h6v6H8z' }),
        _react2.default.createElement('path', { fill: '#1d9bfb', d: 'M26 26h6v6h-6zM8 26h6v6H8z' }),
        _react2.default.createElement('path', { fill: '#25fdfc', d: 'M20 26h6v6h-6zm12 0h6v6h-6zm-18 0h6v6h-6zM26 8h6v6h-6z' }),
        _react2.default.createElement('path', { fill: '#1d9bfb', d: 'M8 8h6v6H8zm12 0h6v6h-6zm12 0h6v6h-6z' }),
        _react2.default.createElement('path', { fill: '#25fdfc', d: 'M14 8h6v6h-6zM8 32h6v6H8zm18 0h6v6h-6z' })
    );
};

exports.default = TraceTypeHeatmapIcon;